var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeghabits0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98389 4.82025C7.89922 4.35375 7.49092 4 7 4H3L2.82025 4.01611C2.35375 4.10078 2 4.50908 2 5L2.01611 5.17975C2.10078 5.64625 2.50908 6 3 6H6V21L6.01611 21.1798C6.10078 21.6462 6.50908 22 7 22H29L29.1798 21.9839C29.6462 21.8992 30 21.4909 30 21V9L29.9839 8.82025C29.8992 8.35375 29.4909 8 29 8H8V5L7.98389 4.82025ZM8 10H28V20H8V10Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.818 25.5C25.818 26.8807 24.6987 28 23.318 28C21.9373 28 20.818 26.8807 20.818 25.5C20.818 24.1193 21.9373 23 23.318 23C24.6987 23 25.818 24.1193 25.818 25.5Z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.318 28C12.6987 28 13.818 26.8807 13.818 25.5C13.818 24.1193 12.6987 23 11.318 23C9.93728 23 8.81799 24.1193 8.81799 25.5C8.81799 26.8807 9.93728 28 11.318 28Z",
    fill: "currentcolor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeghabits0);
export default __webpack_public_path__ + "static/media/seghabits0.684fa22bd80cdde2d7e6adee8f684e38.svg";
export { ForwardRef as ReactComponent };